export default "__VITE_ASSET__FLX0cYtG__"